export enum PaginationCountAs {
  None = 'none',
  Cache = 'cache',
  Exact = 'exact',
}
